import Button from '@space-core/components/button'
import useTranslation from '@space-core/hooks/useTranslation'
import { loginEventDispatch } from '@space-events/login'
import ExceptionState from '@space-shell/common/components/exceptionSate'
import { AuthStatus, useAuthContext } from '@space-shell/common/contexts/auth'
import { SectionEmptyState } from '@space-shell/remotes/preview/components/sectionEmptyState'
import styled from 'styled-components'

const Instructions = styled.div`
  max-width: 42.5rem;
`

export type EmptyClubProps = {
  isPreview?: boolean
}

const EmptyClub = ({ isPreview }: EmptyClubProps) => {
  const { t } = useTranslation()
  const { authStatus } = useAuthContext()

  const isAuthenticated = authStatus === AuthStatus.AUTHENTICATED

  const handleRedirectToSignIn = () => {
    if (isPreview) {
      return
    }

    loginEventDispatch({ signInRedirect: true })
  }

  if (isPreview) {
    return <SectionEmptyState />
  }

  return (
    <div className='_my-12 _mx-4 _d-flex _flex-column _align-items-center'>
      <ExceptionState exception='emptyClub' />

      {!isAuthenticated && (
        <Instructions className='_bg-gray-100 _border _border-gray-200 _rounded-lg _px-5 _py-4 _d-flex _flex-column _flex-md-row _justify-content-between _align-items-center'>
          <p className='_text-gray-900 _text-2 _m-0 _mr-5 _p-0'>
            {t('home.empty_state.instructions')}
          </p>

          <Button
            variation='primary'
            data-test='add-link'
            onClick={handleRedirectToSignIn}
            className='_bg-gray-900 _mt-5 _w-full _mt-md-0 _w-md-auto'>
            {t('home.empty_state.access_account')}
          </Button>
        </Instructions>
      )}
    </div>
  )
}

export default EmptyClub
